import CargoClaims from './CargoClaims';
import CargoClaimDetails from './CargoClaimDetails';

export default CargoClaims;
export { CargoClaimDetails };
